import { AICheckbox } from '../../AICheckbox'
import { CHECKBOX_SIZE } from '../../Checkbox'
import { Container } from '../Container'

function AICheckboxes() {
  return (
    <>
      <Container label='AI Checkbox, off, sizes - 16px, 24px'>
        <AICheckbox size={CHECKBOX_SIZE.small} />
        <AICheckbox />
      </Container>
      <Container label='AI Checkbox, on, sizes - 16px, 24px'>
        <AICheckbox checked size={CHECKBOX_SIZE.small} />
        <AICheckbox checked />
      </Container>
      <Container label='AI Checkbox, intermediate, sizes - 16px, 24px'>
        <AICheckbox selected size={CHECKBOX_SIZE.small} />
        <AICheckbox selected />
      </Container>
      <Container label='AI Checkbox, off, disabled, sizes - 16px, 24px'>
        <AICheckbox disabled size={CHECKBOX_SIZE.small} />
        <AICheckbox disabled />
      </Container>
      <Container label='AI Checkbox, on, disabled, sizes - 16px, 24px'>
        <AICheckbox checked disabled size={CHECKBOX_SIZE.small} />
        <AICheckbox checked disabled />
      </Container>
      <Container label='AI Checkbox, off, with label, sizes - 16px, 24px'>
        <AICheckbox label='Label' size={CHECKBOX_SIZE.small} />
        <AICheckbox label='Label' />
      </Container>
      <Container label='AI Checkbox, on, with label, sizes - 16px, 24px'>
        <AICheckbox checked label='Label' size={CHECKBOX_SIZE.small} />
        <AICheckbox checked label='Label' />
      </Container>
      <Container label='AI Checkbox, on, disabled, with label, sizes - 16px, 24px'>
        <AICheckbox checked disabled label='Label' size={CHECKBOX_SIZE.small} />
        <AICheckbox checked disabled label='Label' />
      </Container>
    </>
  )
}

export default AICheckboxes
